export default __webpack_public_path__ + "static/media/svg-15.378288aa.svg";